module.exports = __webpack_public_path__ + "static/media/cotton.daf77be9.png";